import { createGlobalState } from 'react-hooks-global-state';
const { useGlobalState } = createGlobalState({
    sessionId: null
});
export default function useSessionId() {
    return useGlobalState('sessionId');
}
